import type { PrimarySurface } from '../contracts/types'

const ROUTE_TO_SURFACE: Record<string, PrimarySurface> = {
  '/guided-studio': 'guided_studio',
  '/omnistudio': 'omnistudio',
  '/omnicine': 'omnicine',
  '/omnicast': 'omnicast',
  '/guided/start-from-world': 'guided_studio',
}

const ENTITLED_ROUTE_PREFIXES = [
  '/guided-studio',
  '/omnistudio',
  '/omnicine',
  '/omnicast',
  '/guided/start-from-world',
]

/**
 * Read-only session route hint — does not persist navigation.
 */
export function readSessionSurfaceRouteHint(input: {
  pathname?: string
}): string | undefined {
  const path = input.pathname?.split('?')[0]?.trim()
  if (!path) return undefined

  if (ROUTE_TO_SURFACE[path]) return path

  const match = ENTITLED_ROUTE_PREFIXES.find(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  )
  return match
}

export function mapSessionRouteToSurface(route: string | undefined): PrimarySurface | null {
  if (!route) return null
  const path = route.split('?')[0] ?? route
  if (ROUTE_TO_SURFACE[path]) return ROUTE_TO_SURFACE[path]
  for (const [prefix, surface] of Object.entries(ROUTE_TO_SURFACE)) {
    if (path.startsWith(`${prefix}/`)) return surface
  }
  return null
}
